import React from "react";

function SleeveryResults({ results, searchTerm }) {
  return (
    <div>
      {results && results.sleevery && results.sleevery.sleeves !== 0 && (
        <div className="resultsGroup">
          <div className="sectionTitle">SLEEVERY</div>
          <div className="sectionList">
            <ul>
              <li>
                »{" "}
                <a href={`//www.dreamchimney.com/sleevery/search?page=1&find=${searchTerm}`}>
                  {" "}
                  {results.sleevery.sleeves} sleeve{results.sleevery.sleeves !== 0 ? `s` : ``} found
                </a>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

export default SleeveryResults;
